import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { i18n } from 'config/locales';
import { Modal } from 'components/Modal';
import { updateApplication } from '@redux/modules/application/actions';
import { RootState } from 'types/state';
import { rootSelectors } from '@redux/modules/selectors';
import { ModalButton } from 'components/Modal/Button';

const Consent: React.FC = () => {
  const dispatch = useDispatch();
  const consented = useSelector((state: RootState) => state.application.Settings.consented ?? '');
  const isLoading = useSelector(rootSelectors.api.isLoading);

  const onDismiss = () => dispatch(updateApplication('Settings', 'consented', 'Yes'));

  // This is gated behind isLoading to allow the Loading Modal to take
  // priority when it is on the screen.
  return (
    <Modal
      show={consented !== 'Yes' && isLoading === false}
      className="consent-modal"
      onDismiss={onDismiss}
    >
      <div>
        <div className="consent-legal" tabIndex="0">{i18n.m2('consent.contents')}</div>
        <ModalButton name="consent" className="consent-acceptance">
          {i18n.t('consent.acceptance.title')}
        </ModalButton>
      </div>
    </Modal>
  );
};

export default Consent;
